import script from "./VirusCareModalContent.vue?vue&type=script&setup=true&lang=js"
export * from "./VirusCareModalContent.vue?vue&type=script&setup=true&lang=js"

import "./VirusCareModalContent.vue?vue&type=style&index=0&id=76e7a455&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76e7a455"]])

export default __exports__